/**
 * SightPhones — Theme Interactions
 * Reveal animations · Parallax · Animated counters · Hardware sticky callouts · Nav scroll
 *
 * No dependencies. Drop into Shopify theme as an asset, load deferred in theme.liquid.
 */

(function () {
  'use strict';

  // ─── 1. Reveal animations ──────────────────────────────────────────────────
  // Add class="sp-reveal" (fade up), "sp-reveal-l" (fade left), "sp-reveal-r" (fade right)
  // CSS drives the animation; this just adds .in when element enters viewport.

  function initReveal() {
    var els = document.querySelectorAll('.sp-reveal, .sp-reveal-l, .sp-reveal-r');
    if (!els.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function (el) { obs.observe(el); });
  }


  // ─── 2. Parallax ──────────────────────────────────────────────────────────
  // Mark container: data-parallax="40" (factor in px)
  // First <img> inside is the parallax target.

  function initParallax() {
    var containers = document.querySelectorAll('[data-parallax]');
    if (!containers.length) return;

    var raf = 0;

    function update() {
      containers.forEach(function (c) {
        var img = c.querySelector('img');
        if (!img) return;
        var factor = parseFloat(c.dataset.parallax) || 40;
        var rect = c.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var progress = (center / window.innerHeight) - 0.5;
        img.style.transform = 'translateY(' + (progress * factor) + 'px) scale(1.18)';
      });
    }

    window.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });

    update();
  }


  // ─── 3. Animated counters ─────────────────────────────────────────────────
  // Mark element: data-counter="49g" or data-counter="1500"
  // Counts up when element enters viewport.

  function initCounters() {
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var raw = el.dataset.counter;
        var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (isNaN(num) || num === 0) { el.textContent = raw; return; }
        var suffix = raw.replace(/[0-9.]/g, '');
        var duration = 1400;
        var start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / duration, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(e * num) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { obs.observe(el); });
  }


  // ─── 4. Hardware sticky callouts ──────────────────────────────────────────
  // Container: .sp-callouts  Children: .sp-callout
  // Callout in the middle third of the viewport gets class .active; others get .dim.

  function initHardwareCallouts() {
    var callouts = document.querySelectorAll('.sp-callout');
    if (!callouts.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          entry.target.classList.remove('dim');
        } else {
          entry.target.classList.remove('active');
          entry.target.classList.add('dim');
        }
      });
    }, {
      threshold: 0.5,
      rootMargin: '-15% 0px -15% 0px',
    });

    callouts.forEach(function (el) { obs.observe(el); });
  }


  // ─── 5. Nav scroll state ──────────────────────────────────────────────────
  // Adds .scrolled to .sp-nav after 60px scroll.

  function initNav() {
    var nav = document.querySelector('.sp-nav');
    if (!nav) return;
    function onScroll() {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  // ─── 6. Ken Burns hero ────────────────────────────────────────────────────
  // .sp-kenburns gets the CSS animation applied via class (CSS handles keyframes).
  // Nothing to do in JS — purely CSS-driven. Included here as a reminder.


  // ─── 7. Capability cards reveal ───────────────────────────────────────────
  // .sight-capability-card starts opacity:0 + translateY. Adds .is-visible
  // when card enters viewport. Cards self-stagger via CSS transition-delay.

  function initCapabilityCards() {
    var cards = document.querySelectorAll('.sight-capability-card');
    if (!cards.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    cards.forEach(function (el) { obs.observe(el); });
  }


  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    initReveal();
    initParallax();
    initCounters();
    initHardwareCallouts();
    initNav();
    initCapabilityCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
